import { render, staticRenderFns } from "./FacebookForms.vue?vue&type=template&id=0d2b765f&scoped=true&"
import script from "./FacebookForms.vue?vue&type=script&lang=js&"
export * from "./FacebookForms.vue?vue&type=script&lang=js&"
import style0 from "./FacebookForms.vue?vue&type=style&index=0&id=0d2b765f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b765f",
  null
  
)

export default component.exports